var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"calendar-icon"},[_c('div',{staticClass:"calendar-icon__month"},[_vm._v(_vm._s(_setup.month))]),_c('div',{staticClass:"calendar-icon__date"},[_vm._v(_vm._s(_setup.date))])])
}
var staticRenderFns = []

export { render, staticRenderFns }